import { styled, YStack } from 'tamagui'

export const Separator = styled(YStack, {
  height: 0,
  borderBottomWidth: 0.5,
  borderBottomColor: '$borderColor',

  variants: {
    fullWidth: {
      true: {
        marginHorizontal: '-$4',
      },
    },
  } as const,
})
